import { Box, styled, Typography } from "@mui/material";
import { StyledCustomerInfoCard } from "./CustomerInfoCard.styled";
import { useContext, useState } from "react";
import { DocumentContext } from "../../globals/LanguageContext";
import { Contact } from "../../models/Contact";
import { PencilSimple } from "@phosphor-icons/react";
import { DarkOverlay } from "../darkOverlay/DarkOverlay";

type CustomerInfoCardProps = {
  customerInfo: Contact;
};

export const CustomerInfoCard = ({ customerInfo }: CustomerInfoCardProps) => {
  const { documentDictionary } = useContext(DocumentContext);

  return (
    <StyledCustomerInfoCard>
      <Typography variant="h2" className="head">
        {documentDictionary.customerInfo.title}
      </Typography>
      <Box className="row">
        <Typography variant="h4">{`${customerInfo.company}`}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{`${customerInfo.lastName}`}</Typography>
        <Typography variant="h4">{`${customerInfo.firstName}`}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{customerInfo.address.street}</Typography>
        <Typography variant="h4">{customerInfo.address.number}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{customerInfo.address.zipCode}</Typography>
        <Typography variant="h4">{customerInfo.address.city}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4">{customerInfo.address.country}</Typography>
      </Box>
      <Box className="row" />
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.customerInfo.email}
        </Typography>
        <Typography variant="h4" className="right">{customerInfo.email}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.customerInfo.phone}
        </Typography>
        <Typography variant="h4" className="right">{customerInfo.phone}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.customerInfo.vat}
        </Typography>
        <Typography variant="h4" className="right">{customerInfo.vat}</Typography>
      </Box>
      <Box className="row">
        <Typography variant="h4" className="text">
          {documentDictionary.customerInfo.peppolId}
        </Typography>
        <Typography variant="h4" className="right">{customerInfo.peppolId}</Typography>
      </Box>
    </StyledCustomerInfoCard>
  );
};
